
import React, { useState } from 'react';
import { Utensils } from 'lucide-react';
import { useLanguage } from './LanguageContext';

interface PreloaderProps {
  isExiting: boolean;
}

const Preloader: React.FC<PreloaderProps> = ({ isExiting }) => {
  const [logoError, setLogoError] = useState(false);
  const { language } = useLanguage();

  return (
    <div className={`fixed inset-0 z-[100] flex items-center justify-center ${isExiting ? 'pointer-events-none' : ''}`}>
      
      {/* Left Curtain Panel */}
      <div 
        className={`absolute top-0 left-0 w-1/2 h-full bg-[#1a120b] border-r border-fait-gold/10 transition-transform duration-1000 ease-[cubic-bezier(0.77,0,0.175,1)] origin-left ${
          isExiting ? '-translate-x-full' : 'translate-x-0'
        }`}
      />

      {/* Right Curtain Panel */}
      <div 
        className={`absolute top-0 right-0 w-1/2 h-full bg-[#1a120b] border-l border-fait-gold/10 transition-transform duration-1000 ease-[cubic-bezier(0.77,0,0.175,1)] origin-right ${
          isExiting ? 'translate-x-full' : 'translate-x-0'
        }`}
      />

      {/* Logo Container */}
      <div 
        className={`relative z-10 flex flex-col items-center transition-all duration-700 ease-in-out ${
          isExiting ? 'opacity-0 scale-150 blur-sm' : 'opacity-100 scale-100'
        }`}
      >
        {!logoError ? (
            <img 
            src="/images/logo.svg" 
            alt="Loading..."
            // Increased size: h-32 on mobile, h-64 on desktop
            className="h-32 md:h-64 w-auto object-contain animate-pulse duration-[2000ms] drop-shadow-[0_0_25px_rgba(206,172,100,0.3)]"
            onError={() => setLogoError(true)}
            />
        ) : (
            <div className="flex flex-col items-center gap-6 animate-pulse duration-[2000ms]">
                <Utensils className="h-24 w-24 md:h-32 md:w-32 text-fait-gold" />
                <span className="font-serif text-5xl md:text-7xl font-bold text-fait-cream tracking-wide">
                    {language === 'he' ? 'יהודה פייט' : 'Yehuda Fait'}
                </span>
            </div>
        )}
      </div>
    </div>
  );
};

export default Preloader;
